// extracted by mini-css-extract-plugin
export default {"errorMessage":"MainTable_errorMessage__XBqUd","maintable":"MainTable_maintable__RbwI6"};